import React from 'react'
import CourseHeader from '../components/CourseHeader'
import CompletedSolutions from '../section/completedsolutionpage/CompletedSolutions'

export default function CompletedSolutionPage() {
  return (
    <div>
      <CourseHeader />
      <div className="min-h-screen bg-[#F8FAFC] pt-24">
        <CompletedSolutions />
      </div>
    </div>
  )
}
